// WORK SCHEDULE PAGE

export const daysOfWeek = [1, 2, 3, 4, 5, 6, 0];

// DRIVER PROFILE PAGE
export const phoneNumberRegex = new RegExp(
  "^[0]?([1-6][0-9]{8,10}|7[0-9]{9})$"
);

export const odfDriverCodeRegex = new RegExp("([0-9]{4})[*][F][D][0-9]{1,10}$");

export const drDriverCodeRegex = new RegExp("([0-9]{4})[*][D][R][0-9]{1,10}$");

export const robotDriverCodeRegex = new RegExp(
  "([0-9]{4})[*][R][B][0-9]{1,10}$"
);

export const newDriverCodeRegex = new RegExp("^([0-9]{4})[*][A-Z0-9]+$");
